import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from 'src/services/api.service';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from "@angular/forms";
import { goToLoginIfNotLoggedIn } from 'src/services/ObservableExtension';
import { Router } from '@angular/router';

@Component({
  selector: 'app-access-management',
  templateUrl: './access-management.component.html',
  styleUrls: ['./access-management.component.scss']
})
export class AccessManagementComponent implements OnInit {

  users = [];

  admins = [];

  modal: NgbModalRef;

  isAdmin = false;

  newUser: any = {};
  errorMessage: string = "";
  submitted: boolean = false;

  @ViewChild('userModal')
  userModal: ElementRef;

  constructor(
    public api: ApiService,
    private ngbModal: NgbModal,
    private router: Router)
  {
    api.pageTitle = 'Zugriffsrechte';
  }

  ngOnInit() {
    this.api.get('users/current').pipe(goToLoginIfNotLoggedIn(this.router)).subscribe((r: any) => {
      this.users = r.Users;
      this.admins = r.Admins;

      var hasPermission = r.Permission ? r.Permission.IsAdmin : false;
      this.isAdmin = this.api.isPlatformAdmin || hasPermission;
    });

  }

  addAdmin() {
    this.errorMessage = "";
    this.newUser = {
      IsAdmin: true
    };
    this.showModal();
  }

  addUser() {
    this.errorMessage = "";
    this.newUser = {
      IsAdmin: false
    };
    this.showModal();
  }

  delete(u) {
    this.api.delete('users/' + u.Id).subscribe(d => {
      var indexInAdmins = this.admins.indexOf(u);
      var indexInUsers = this.users.indexOf(u);
      if (indexInAdmins >= 0) this.admins.splice(indexInAdmins, 1);
      if (indexInUsers >= 0) this.users.splice(indexInUsers, 1);
    })
  }

  showModal() {
    this.modal = this.ngbModal.open(this.userModal, { size: 'lg' });
  }

  save(form: NgForm) {
    this.submitted = true;
    if (form.valid) {
      this.submitted = false;
      this.api.post('users', this.newUser).subscribe((d: any) => {
        if (!d.Success) this.errorMessage = d.ErrorMessage;
        else {
          if (this.newUser.IsAdmin) this.admins.push(this.newUser);
          else this.users.push(this.newUser);
          this.newUser = null;
          this.modal.close();
        }
      });
    }
  }
}
